<template>
<div>
  <w-table ref="wMyTable" :columns="columns" :table-data="tableData"
           @getTableSearchSortCon="getTableSearchSortCon" :isPagination="true"
           :page="page" @pageChange="handlePagePagination">
    <div slot="principal" slot-scope="{record}">
      <el-select style="width: 150px" v-model="principalUuids[record.id]" placeholder="请选择" filterable>
        <el-option v-for="item in PersonOptions" :key="item.uuid" :label="item.name"
                   :value="item.uuid"></el-option>
      </el-select>
    </div>
  </w-table>
</div>
</template>

<script>

import {tableOperationMixin} from "@/mixins/tableOperation";
import {getInvoiceTableCol} from "@/utils/data/tableCol/invoice/invoiceTableCol";
import {getTicketsPage} from "@/api/dilivery/tickets";
import {getDataInLocalStorage} from "@/utils/localStorage";

export default {
  name: "InvoiceInfoDialog",
  mixins: [tableOperationMixin],
  props: {
    title: {
      default: '发票'
    },
    type:{
    },
    showDialog: {
      default: true
    },
    selectDetail:{
      default:()=>({})
    },
    principalUuids:{
      default:()=>({})
    },
    PersonOptions:{
      default:()=>([])
    }
  },
  data(){
    return{
      tableData: [],
      role:'',
      searchConditionTag:[],
      sortConditionTag:[],
      page: {
        pageSize: 10,
        currentNum: 1,
        total: null
      },
    }
  },
  watch:{
    principalUuids:{
      handler(newVal){
        this.$emit('submit',newVal)
      },
      immediate:true,
      deep:true
    }
  },
  computed: {
    columns() {
      if(this.type && this.type === 'audit'){
        return getInvoiceTableCol(this.searchConditionTag || [])
      }else{
        return getInvoiceTableCol(this.searchConditionTag || []).filter(item => item.key!=='principal')
      }
    }
  },
  mounted() {
    this.getData()
  },
  created() {
    this.role = getDataInLocalStorage('role')
  },
  methods: {
    getData(isSearch) {
      const param = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      };
      if (isSearch === 'search') {
        param['page.current'] = 1
        param['page.size'] = 10
      }
      let sendData = {
        "query#invoiceRecordId.EQ":this.selectDetail.id
      }
      if (this.role === 'BUSINESS_COMMERCIAL') {
        sendData['permissionInitiatedFlag'] = false
      }
      let length = this.searchConditionTag.length
      if (length) {
        this.searchConditionTag.forEach(item => {
          let key = item.key
          sendData[key] = item.value
          sendData["query#"+key+".LIKE"] = item.value
        })
      }
      param.order = this.sortConditionTag.length > 0 ? `${this.sortConditionTag[0].colName}.${this.sortConditionTag[0].order}` : ''
      getTicketsPage(param, sendData).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
        }
      })
    },
    //获取表格搜索条件
    getTableSearchSortCon(searchConditionTag, sortConditionTag) {
      this.searchConditionTag = searchConditionTag
      this.sortConditionTag = sortConditionTag
      this.getData('search')
    },
    //分页
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
  }
}
</script>

<style scoped>

</style>
